import { Component } from '@angular/core';

@Component({
  selector: 'app-who-should-join',
  templateUrl: './who-should-join.component.html'
})
export class WhoShouldJoinComponent { }
